<div id="app">
    <div class="global-header-wrapper">
        <div class="global-header"></div>
    </div>
    <div class="aeg-header-wrapper" v-if="showAdminNavigation">
        <aeg-admin-header class="aeg-header-wrapper__admin-navigation" />
    </div>
    <div class="content">
        <vl-page>
            <vl-region v-if="isLoadingUserData && !allowAnonymous">
                <vl-layout>
                    <div v-vl-align:center>
                        <vl-loader message="De gegevens worden geladen. Even geduld, a.u.b."></vl-loader>
                    </div>
                </vl-layout>
            </vl-region>
            <vl-main v-else-if="isAuthenticated || allowAnonymous">
                <aeg-application-announcements />
                <router-view mode="out-in" />    
            </vl-main>
        </vl-page>
    </div>

    <vl-toaster mod-bottom-right>
        <vl-alert
                v-for="alert in alerts"
                :key="alert.id"
                :icon="alert.icon"
                :title="alert.title"
                :closable="alert.closable"
                :mod-success="alert.type === 'mod-success'"
                :mod-warning="alert.type === 'mod-warning'"
                :mod-error="alert.type === 'mod-error'"
                @close="closeAlert(alert.id)">
            <div v-html="alert.message"></div>
        </vl-alert>
    </vl-toaster>
    
    <div class="global-footer-wrapper">
        <div class="global-footer"></div>
    </div>
</div>